import { Component, DestroyRef, ElementRef, ViewChild, OnInit } from '@angular/core';

import { ToastService } from 'shared/services';
import { AuthenticationService } from 'authentication/services/authentication.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SharedModule } from 'shared/shared.module';
import { catchError, EMPTY } from 'rxjs';
import { SSOInternalErrorCodesEnum } from 'authentication/enums/sso-internal-error-codes.enum';
import { Router } from '@angular/router';
import { extractQueryParamsFromUrl } from 'shared/util/extractQueryParamsFromUrl';

@Component({
    selector: 'app-external-redirect',
    imports: [SharedModule],
    templateUrl: './external-redirect.component.html',
    styleUrls: ['./external-redirect.component.scss'],
})
export class ExternalRedirectComponent implements OnInit {
    @ViewChild('icePortalForm') protected icePortalForm!: ElementRef;

    constructor(
        private toastService: ToastService,
        private authService: AuthenticationService,
        private destroyRef: DestroyRef,
        private router: Router,
    ) {}

    public ngOnInit(): void {
        this.authService
            .redirectToIcePortal()
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                catchError((error) => {
                    if (error?.status === 401) {
                        switch (error?.error?.ErrorCode) {
                            case SSOInternalErrorCodesEnum.InvalidToken:
                                this.toastService.showToast('sso.icePortal.invalidToken', 'error');
                                break;
                            case SSOInternalErrorCodesEnum.UserNotFound:
                                this.toastService.showToast('sso.icePortal.userNotFound', 'error');
                                break;
                            case SSOInternalErrorCodesEnum.InvalidUser:
                                this.toastService.showToast('sso.icePortal.invalidUser', 'error');
                                break;
                            case SSOInternalErrorCodesEnum.AccountLocked:
                                this.toastService.showToast('sso.icePortal.accountLocked', 'error');
                                break;
                            case SSOInternalErrorCodesEnum.InternalServerError:
                                this.toastService.showToast('sso.icePortal.internalServerError', 'error');
                                break;
                            default:
                                this.toastService.showToast('sso.icePortal.unexpected', 'error');
                                break;
                        }

                        this.redirectUser();
                        return EMPTY;
                    }

                    this.redirectUser();
                    throw error;
                }),
            )
            .subscribe((response) => {
                this.icePortalForm.nativeElement.setAttribute('action', response.RedirectUrl);
                this.icePortalForm.nativeElement.children['EncryptedData']?.setAttribute('value', response.EncryptedData);

                this.icePortalForm.nativeElement.submit();
            });
    }

    private redirectUser() {
        //If the user tried to navigate to this route using the address bar, the location object holds the /icePortal path instead of the previous route
        if (location.pathname === '/icePortal') {
            window.history.replaceState(null, '', `/dashboard`);
            this.router.navigate(['/dashboard']);
        }

        this.router.navigate([location.pathname], { queryParams: extractQueryParamsFromUrl(location.href) });
    }
}
